import { render, staticRenderFns } from "./editOurService.vue?vue&type=template&id=f1e4d0d0&"
import script from "./editOurService.vue?vue&type=script&lang=js&"
export * from "./editOurService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports